import { GetSectionResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../services/core-api-service";

export const getSection = (sectionId: string): Promise<GetSectionResult> => {
    return api.assessmentSections.getSectionById(sectionId);
}